
import { css } from 'styled-components';

export const boxShadow = css`
    box-shadow: 0 2px 3px -1px rgba(0,0,0,.15);
`;
